<template lang="pug">
.history-browsering.history-browsering--log.is-certificate
    .flex.flex-wrap.-mx-4
        template(v-if="load_data_status_browsing.status === 'loading' && load_data_status_browsing_count.log === 'loading'")
            Loading(show="true")
        template(v-else)
            
            //- span(v-if='filterNull') No Data in Filter
            NoDataAvailable(v-if='filterNull')
            template(v-else-if="browsing_log.chart_certificate && browsing_log.chart_certificate.categories !== undefined && Object.keys(browsing_log.chart_certificate.series).length > 0 && Object.keys(browsing_log.summary_certificate).length > 0")
                .block.px-4(class="w-full lg:w-4/6")
                    .box-chart.border.p-4.rounded
                        highcharts(:options="chartOptions")
                .block(class="w-full lg:w-2/6 p-8 lg:p-4")
                    .block.mb-4
                        span.text-light SSL
                        h2.monospace {{browsing_log.summary_certificate.ssl}}
                    .block.mb-4
                        span.text-light NON SSL
                        h2.monospace {{browsing_log.summary_certificate.non_ssl}}
            NoDataAvailable(v-else)
</template>

<script>
import { mapState } from 'vuex';
import Loading from '@/components/Loading.vue';
import NoDataAvailable from '@/components/NoDataAvailable.vue';
export default {
    name: 'logCertificate',
    components: {
        Loading,
        NoDataAvailable,
    },
    data() {
        return {
            title: '',
            chartType: 'bar',
            seriesColor: '#6fcd98',
            colorInputIsSupported: null,
            filterNull: false,
            chartOptions: {
                chart: {
                    type: 'bar'
                },
                title: {
                    text: null
                },
                xAxis: {
                    categories: [],
                    title: {
                        text: null
                    }
                },
                yAxis: {
                    title: {
                        text: null
                    },
                },
                series: []
            },
            dataCat: null,
            dataSeries: null
        }
    },
    computed: {
        ...mapState([
          'load_data_status_browsing',
          'load_data_status_browsing_count',
          'browsing_log',
        ]),
    },
    watch: {
        browsing_log() {
            if (this.browsing_log.chart_certificate && Object.prototype.hasOwnProperty.call(this.browsing_log.chart_certificate, "categories") && Object.keys(this.browsing_log.chart_certificate).length > 0 && Object.keys(this.browsing_log.chart_certificate.series).length > 0) {
               this.filterChart()
            }
        },
        filterDateRange() {},
    },
    methods: {
        // dateFormat (classes, date) {
        //     let startDate = new Date(this.from_date);
        //     let endDate = new Date(this.end_date);
        //     if (!classes.disabled) {
        //       classes.disabled = date.getTime() < startDate.getTime() || date.getTime() > (endDate.getTime() + 86400000)
        //     }
        //     return classes
        // },
        // avgArray(arr){
        //     var total = 0;
        //     for(var i = 0; i < arr.length; i++) {
        //         total += arr[i];
        //     }
        //     var avg = total / arr.length;
        //     return Math.round(avg)
        // },
        // compareAvg(arr, sort='desc'){
        //     return arr.slice().sort(function(a, b) {
        //         if (sort == 'desc') {
        //             return b.data - a.data;
        //         } else {
        //             return a.data - b.data;
        //         }
        //     });
        // },
        // resetChart(){
        //     this.$swal.fire({
        //         icon: 'warning',
        //         title: 'Are you sure you want to reset Application in Application Usage?',
        //         confirmButtonText: 'Yes!',
        //         confirmButtonColor: '#DD6B55',
        //         showCancelButton: true,
        //         allowOutsideClick: false,
        //     })
        //     .then((result) => {
        //         if (result.isConfirmed) {
        //             // this.filterDateRange.startDate = localStorage.getItem('from_date')
        //             // this.filterDateRange.endDate = localStorage.getItem('end_date')
        //             this.filterDateRange.startDate = this.from_date
        //             this.filterDateRange.endDate = this.end_date
        //             this.filterSort = 'desc'
        //             this.filterSize = 20
        //             this.filterChart()
        //         }
        //     });
        // },
        filterChart(){
            // definition
            this.dataCat = Object.assign([], JSON.parse(JSON.stringify(this.browsing_log.chart_certificate.categories)));
            this.dataSeries = Object.assign([], JSON.parse(JSON.stringify(this.browsing_log.chart_certificate.series)));
            // let startFilter = new Date(this.filterDateRange.startDate).setHours(0,0,0,0);
            // let endFilter = new Date(this.filterDateRange.endDate).setHours(23,59,59,59);
            // let count = [];
            var categoriesCertificate = []
            // var seriesNameCertificate = 'Certificate Log'
            var seriesDataCertificate = []
            // var tmpDataBrowser = []

            // filter by date
            // console.log('=====this.dataCat')
            // console.log(this.dataCat)
            // this.dataCat = this.dataCat.filter((item, i) => {
            //     if (new Date(item).getTime() >= startFilter && new Date(item).getTime() <= endFilter) {
            //         count.push(i)
            //     }
            //     // console.log(startFilter)
            //     // console.log(new Date(item).getTime())
            //     // console.log(endFilter)
            //     return new Date(item).getTime() >= startFilter &&
            //            new Date(item).getTime() <= endFilter;

            // });
            // console.log(this.dataCat)
            // console.log(this.dataCat.length)
            if (this.dataCat.length == 0) {
                this.filterNull=true
            } else {
                this.filterNull=false            

                // filter data by date
                // console.log('=====this.dataSeries')
                // console.log(this.dataSeries)
                // this.dataSeries = this.dataSeries.map((is) => {
                //     let tmp = count.map((is2) => {
                //                 return is.data[is2];
                //             })
                //     is.data = tmp
                //     return is
                // });
                // console.log(this.dataSeries)
                
                // tmp data avg
                // console.log('=====this.tmpDataBrowser')
                // console.log(tmpDataBrowser)
                // for (var i = 0; i < this.dataSeries.length; i++){ 
                //     var tmpDAU = {
                //         name: this.dataSeries[i].name,
                //         data: this.avgArray(this.dataSeries[i].data)
                //     }
                //     tmpDataBrowser.push(tmpDAU)
                // }
                // console.log(tmpDataBrowser)

                // sort by avg
                // tmpDataBrowser = this.compareAvg(tmpDataBrowser, this.filterSort)
                // console.log('=====this.tmpDataBrowser:sort')
                // console.log(tmpDataBrowser)
                // for (var j = 0; j < this.filterSize; j++){ 
                //     categoriesCertificate.push(tmpDataBrowser[j].name)
                //     seriesDataCertificate.push(tmpDataBrowser[j].data)
                // }
                // console.log('=====this.categoriesCertificate')
                // console.log(categoriesCertificate)
                // console.log('=====this.seriesDataCertificate')
                // console.log(seriesDataCertificate)
                // console.log('=====this.seriesNameCertificate')
                // console.log(seriesNameCertificate)
                // update chart
                categoriesCertificate = this.dataCat
                seriesDataCertificate = this.dataSeries
                
                this.chartOptions.xAxis.categories = categoriesCertificate;
                this.chartOptions.series = seriesDataCertificate
                // this.chartOptions.series = [{
                //     data: seriesDataCertificate,
                //     name: seriesNameCertificate,
                // }];
            }
        }
    },
    mounted() {
        if (this.browsing_log.chart_certificate && Object.prototype.hasOwnProperty.call(this.browsing_log.chart_certificate, "categories") && Object.keys(this.browsing_log.chart_certificate).length > 0 && Object.keys(this.browsing_log.chart_certificate.series).length > 0) {
           this.filterChart()
        }
    },
}
</script>

